import { useNavigate } from 'react-router-dom'
import { useDocumentTitle } from '@/shared/hooks/use-document-title'
import { Button } from '@/components/ui/button'
import { ArrowLeft } from 'lucide-react'
import { useCrearEncuesta } from '../hooks/useEncuestas'
import { EncuestaForm } from '../components/EncuestaForm'
import type { EncuestaCreatePayload } from '../types'

export function EncuestaCreatePage() {
  useDocumentTitle('Nueva Encuesta')
  const navigate = useNavigate()
  const crearMutation = useCrearEncuesta()

  const handleSubmit = async (data: EncuestaCreatePayload) => {
    const result = await crearMutation.mutateAsync(data)
    navigate(`/encuestas/${result.id}/editar`)
  }

  return (
    <div className="space-y-6">
      <div className="flex items-center gap-4">
        <Button variant="ghost" size="sm" onClick={() => navigate('/encuestas')}>
          <ArrowLeft className="mr-2 h-4 w-4" /> Volver
        </Button>
        <h1 className="text-3xl font-bold tracking-tight">Nueva Encuesta</h1>
      </div>

      <div className="max-w-3xl">
        <EncuestaForm
          onSubmit={handleSubmit}
          isSubmitting={crearMutation.isPending}
          mode="create"
        />
      </div>
    </div>
  )
}
